// extracted by mini-css-extract-plugin
module.exports = {"companyDescriptionWrapper":"styles_companyDescriptionWrapper__3FWJz"};